<div class="calendar-header">
    <button (click)="previousClicked()" class="btn btn-light" [disabled]="backDisabled()">
        <i class="fas fa-chevron-left"></i>
    </button>
    <span class="calendar-label">{{periodLabel}}</span>
    <button (click)="nextClicked()" class="btn btn-light">
        <i class="fas fa-chevron-right"></i>
    </button>
</div>